import * as Actions from "../actions";

const initialState = {
  success: false,
  isResetPassLoading: false,
  errorResetPass: null,
};

const resetPass = function (state = initialState, action) {
  switch (action.type) {
    case Actions.RESET_PASS_FETCH_START: {
      return {
        ...initialState,
        isResetPassLoading: true,
      };
    }
    case Actions.RESET_PASS_FETCH_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isResetPassLoading: false,
      };
    }
    case Actions.RESET_PASS_FETCH_FAILURE: {
      return {
        success: false,
        isResetPassLoading: false,
        errorResetPass: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default resetPass;
